import { FOfferType } from '../../../utils/offer_type';
/**
 * Для квартир, комнат, домов, таунхаусов и офисов нужно дописывать
 * "уютный/уютную", в остальных случаях - нет.
 */

export function isCozyOfferType(offerType?: FOfferType): boolean {
  switch (offerType) {
    case FOfferType.Flat:
    case FOfferType.FlatOld:
    case FOfferType.FlatNew:
    case FOfferType.Room:
    case FOfferType.House:
    case FOfferType.Townhouse:
    case FOfferType.Office:
      return true;
    default:
      return false;
  }
}
